import { render, staticRenderFns } from "./ContractLiveTalk.vue?vue&type=template&id=650ff30c&scoped=true&"
import script from "./ContractLiveTalk.vue?vue&type=script&lang=js&"
export * from "./ContractLiveTalk.vue?vue&type=script&lang=js&"
import style0 from "./ContractLiveTalk.vue?vue&type=style&index=0&id=650ff30c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650ff30c",
  null
  
)

export default component.exports